export default __webpack_public_path__ + "static/media/infobanner1.1efb55b5.svg";